/**
 * Типографика сообщения Telegram. docs/ui-design.md §6, docs/phase-1/05-ui.md §3.5.
 *
 * НИ ОДНОГО токена GeoBoost — здесь заканчивается наш бренд и начинается чужой клиент.
 * Значения либо взяты из утверждённого дизайна v1.0 (блок .tg* в src/styles/base.css),
 * либо являются продолжением его палитры теми же числами. Правило не про чистоту:
 * фирменная примесь в превью прямо мешает единственной работе панели — показать пост так,
 * как его увидит подписчик.
 *
 * Косметика здесь — приближение и правится по скриншотам из настоящего клиента (ПРАВИЛО 6.3).
 * Структура (диапазоны, порядок, свёрнутость цитат, положение подписи) — не косметика,
 * и живёт не в этом файле, а в дереве сущностей.
 */

/* ── тело сообщения ── */

/* pre-wrap, а не <br>: §3.2. Перенос длинного слова обязателен — колонка фиксированная. */
.body {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

/* ── код ── */

/*
 * Гарнитура наследуется от `.tg` — моноширинного начертания в интерфейсе нет нигде
 * (решение заказчика 26.08.2026), и превью не исключение. Отличие `code` от обычного текста
 * держат подложка и скругление, а не начертание: сущность `code` в посте всё равно видна.
 * Цена решения названа честно: настоящий клиент Telegram рисует `code`/`pre` моноширинным,
 * и в этой одной детали превью перестало быть точным. Это отступление от docs/ui-design.md
 * §6 (строка «code / pre — моноширинный»), и оно сознательное.
 */
.code {
  font-size: 13.5px;
  background: rgba(16, 35, 47, 0.07);
  border-radius: 6px;
  padding: 1px 4px;
}
:global(.tg.dark) .code {
  background: rgba(255, 255, 255, 0.1);
}

.pre {
  position: relative;
  font-size: 13.5px;
  line-height: 1.45;
  background: rgba(16, 35, 47, 0.07);
  border-radius: 8px;
  padding: 9px 11px;
  margin: 7px 0 9px;
  /* Переносы внутри блока кода не сворачиваются — §3.2. */
  white-space: pre-wrap;
  overflow-x: auto;
}
:global(.tg.dark) .pre {
  background: rgba(255, 255, 255, 0.08);
}

/* Подпись языка — псевдоэлемент, а не узел: она не имеет права попадать в textContent
   контейнера, иначе текст превью перестанет совпадать с текстом поста. */
.pre[data-lang]::before {
  content: attr(data-lang);
  position: absolute;
  top: 5px;
  right: 9px;
  font-size: 10px;
  letter-spacing: 0.04em;
  color: #8e9aa3;
  user-select: none;
}

/* ── спойлер: закрыт по умолчанию, раскрывается кликом ── */

.spoiler,
.spoilerOpen {
  display: inline;
  font: inherit;
  color: inherit;
  text-align: left;
  background: none;
  border: none;
  padding: 0;
  margin: 0;
}
.spoiler {
  background: rgba(16, 35, 47, 0.22);
  border-radius: 4px;
  color: transparent;
  text-shadow: 0 0 8px rgba(16, 35, 47, 0.75);
  cursor: pointer;
}
:global(.tg.dark) .spoiler {
  background: rgba(255, 255, 255, 0.22);
  text-shadow: 0 0 8px rgba(255, 255, 255, 0.75);
}
.spoilerOpen {
  cursor: default;
}

/* ── сворачиваемая цитата ── */

/* Три строки при line-height 1.35 — столько показывает клиент до «Развернуть». */
.quoteCollapsed {
  display: block;
  max-height: 4.05em;
  overflow: hidden;
  mask-image: linear-gradient(to bottom, #000 60%, transparent 100%);
}
.quoteFull {
  display: block;
}
.quoteToggle {
  display: block;
  margin-top: 3px;
  padding: 0;
  border: none;
  background: none;
  font: inherit;
  font-size: 12.5px;
  color: #168acd;
  cursor: pointer;
}
:global(.tg.dark) .quoteToggle {
  color: #71baf2;
}

/* ── медиа ── */

/* Подложка честно показывает то, что сделает Telegram: альфу он не сохраняет — фото
   пережимается в JPEG, — поэтому прозрачный PNG у подписчика ляжет на непрозрачный фон.
   Она же занимает место, пока байты едут: в тёмной теме без неё в пузыре чёрная дыра. */
.mediaBox {
  position: relative;
  line-height: 0;
  background: #cfd8e0;
  overflow: hidden;
}
:global(.tg.dark) .mediaBox {
  background: #223140;
}
/* `height: 100%` — потому что у бокса теперь задано соотношение сторон; `contain` вместо
   растяжения: если присланные размеры разойдутся с байтами, картинка встанет с полями,
   а не исказится. */
.mediaImg {
  display: block;
  max-width: 100%;
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.mediaFail {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 14px;
  text-align: center;
  font-size: 12.5px;
  line-height: 1.35;
  color: #5d6a75;
}
:global(.tg.dark) .mediaFail {
  color: #8fa0ae;
}
/* Та же накладка, что у сущности spoiler: has_spoiler — это спойлер, только на картинке. */
.mediaCover {
  position: absolute;
  inset: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: none;
  background: rgba(16, 35, 47, 0.55);
  backdrop-filter: blur(16px);
  color: #ffffff;
  font-family: inherit;
  font-size: 12.5px;
  line-height: 1.35;
  cursor: pointer;
}
/* У накладки спойлера тёмного варианта не было: сине-серая полупрозрачность на тёмном
   фоне пузыря даёт грязь вместо матового стекла. */
:global(.tg.dark) .mediaCover {
  background: rgba(0, 0, 0, 0.62);
}

/* ── документ (PDF внизу поста, docs/release-2026-09-19.md §9.2) ── */

/*
 * Последний блок пузыря, как у клиента: круглый значок, имя, размер. Цвета — палитра
 * клиента (синий Telegram тот же, что у ссылки `.tg-a`), а не токены GeoBoost: внутри `.tg`
 * наш бренд кончается (docs/ui-design.md §6). Ссылкой он становится, только когда известен
 * адрес байтов, — поэтому цвет и подчёркивание ссылки здесь сняты: в клиенте это блок, а не
 * текстовая ссылка.
 */
.doc {
  display: flex;
  align-items: center;
  gap: 11px;
  margin-top: 9px;
  color: inherit;
  text-decoration: none;
  min-width: 0;
}
.docIcon {
  flex: none;
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: #3a9ae8;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}
:global(.tg.dark) .docIcon {
  background: #5288c1;
}
.docText {
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
}
.docName {
  font-size: 14.5px;
  font-weight: 500;
  line-height: 1.3;
  overflow-wrap: anywhere;
}
/* Под курсором цвет не меняется: `a:hover` из base.css (0,1,1) сильнее `.doc` (0,1,0) и
   красил имя файла в `--violet-dark` — на тёмном пузыре это ~1,45:1, имя пропадало ровно под
   курсором, и фирменный токен оказывался внутри `.tg` (ревью 19.09.2026, ui-6). */
a.doc:hover {
  color: inherit;
}
a.doc:hover .docName {
  text-decoration: underline;
}
.docSize {
  font-size: 13px;
  line-height: 1.3;
  color: #8e9aa3;
  font-variant-numeric: tabular-nums;
}
:global(.tg.dark) .docSize {
  color: #6d7f8f;
}

/* ── подвал-иллюстрация ── */

.footIcon {
  width: 13px;
  height: 13px;
}

/* ── пометки сравнения версий ── */

/*
 * Это НАША аннотация поверх чужого клиента, и она единственная в этой панели. Токены
 * GeoBoost внутри `.tg` запрещены (§6), поэтому подложки заданы теми же числами, что стоят
 * у `--red-bg`/`--red-ink` и `--green-bg`/`--green-ink`: «убрали» и «добавили» обязаны
 * читаться одинаково на всём экране. Пометки видны только в режиме сравнения — в режиме
 * чтения `marks` равно null и разметка листьев не меняется вовсе.
 */
.markDel,
.markIns {
  border-radius: 3px;
  padding: 0 2px;
}
.markDel {
  background: #fbe9ea;
  color: #c43a40;
  text-decoration: line-through;
  text-decoration-thickness: 1px;
}
.markIns {
  background: #e3f4ea;
  color: #138a4b;
  text-decoration: none;
}

/* ── аварийный текст: дерево не построилось ── */

.renderFail {
  margin: 10px 0 0;
  font-size: 12px;
  line-height: 1.45;
  color: #d14836;
}
